<template>
  <b-col sm="12" :lg="lgSize">
    <div class="animated fadeIn">
      <DateModal
        modalID="delivered_total_fns"
        :fetchData="fetchData"
        :dateFrom="dateFrom"
        :dateTo="dateTo"
        @date-picker-modal-emit="onDatePickerModalEmit"
      ></DateModal>
      <b-card class="backClass" style="height:450px" header="Received">
        <div slot="header" style="display:flex;justify-content: space-between;">
          <div style="display:flex;">
            <HeaderTitle
              title="Delivered By FNS"
              :dateFrom="
                from(dateFrom)
                  ? $formatUSDate(from(dateFrom))
                  : $formatUSDate(dateFrom)
              "
              :dateTo="
                to(dateTo) ? $formatUSDate(to(dateTo)) : $formatUSDate(dateTo)
              "
            ></HeaderTitle>
            <HeaderControl
              :showDateIcon="true"
              @emit-date="modalDateEvent"
            ></HeaderControl>
          </div>
          <div style="width:auto">
            <b-input-group size="sm">
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>
        <div class>
          <LoadingCard v-if="loadingData"></LoadingCard>
          <div v-else>
            <b-table
              responsive
              style="height:350px"
              :filter="filter"
              :fields="fields"
              size="lg"
              :items="items"
            >
              <template v-slot:cell(user)="{ value }">
                <img :src="value" width="40px" style="border-radius: 100px;" />
              </template>
              <template v-slot:cell(image)="row">
                <b-button
                  size="sm"
                  @click="
                    $router.push(
                      '/base/ProofOfDelivery/details/?ranum=' +
                        row.item.ranum +
                        '&shipDate=' +
                        row.item.shipDate
                    )
                  "
                  class="mr-1"
                >
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </b-button>
              </template>
            </b-table>
          </div>
        </div>
        <b-modal id="myModal" :title="seekTitle" ok-only @hide="resetInfoModal">
          <img :src="seekImage" width="100%" />
        </b-modal>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../router";
import Datepicker from "vuejs-datepicker";
import cTable from "../../views/base/tables/Table";
import DateModal from "../shared/DateModal.vue";
import HeaderTitle from "../shared/HeaderTitle.vue";
import HeaderControl from "../shared/HeaderControl.vue";
import LoadingCard from "../shared/LoadingCard.vue";
import { from, isUserLoggedIn, to } from "../../utils/Utils";

export default {
  name: "DeliveredTotalByFNS",
  components: {
    router,
    cTable,
    highcharts: Chart,
    Datepicker,
    DateModal,
    HeaderTitle,
    HeaderControl,
    LoadingCard
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity"],
  data: function() {
    return {
      from: from,
      to: to,
      filter: null,
      fullscreen: false,
      loadingData: false,
      showAll: false,
      modalDate: false,
      dateFrom: "",
      dateTo: "",
      city: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      title: "",
      items: [],
      seekImage: "",
      seekTitle: "",
      fields: [
        { key: "ranum", label: "RMA" },
        {
          key: "shipDate",
          label: "Ship Date",
          formatter: (value, key, item) => {
            return this.$formatUSDate(item.shipDate);
          }
        },
        { key: "units", label: "Units" },
        { key: "image", label: "Details" }
      ],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  methods: {
    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.dateFrom = changedDateFrom
        ? new Date(changedDateFrom).toISOString().split("T")[0]
        : changedDateFrom;
      this.dateTo = changedDateTo
        ? new Date(changedDateTo).toISOString().split("T")[0]
        : changedDateTo;
    },
    modalDateEvent() {
      this.$bvModal.show("delivered_total_fns");
    },
    info(item) {
      this.seekTitle = `RMA: ${item.ranum}`;
      this.seekImage =
        "https://fibernode.com/storage/proof-of-delivery/" + item.image;
      this.$bvModal.show("myModal");
    },
    resetInfoModal() {
      this.seekTitle = "";
      this.seekImage = "";
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        clients: this.locationsIds,
        date_from: this.dateFrom,
        date_to: this.dateTo
      };
      this.$http
        .get("api/tables/pod_total.php", {
          params
        })
        .then(
          res => {
            this.loadingData = false;
            this.title = "Total records: " + res.data.count;
            this.items = res.data.records;
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    }
  },
  mounted() {
    isUserLoggedIn(router);
    const date = new Date();
    date.setDate(date.getDate() - 30);
    this.dateFrom = date.toISOString().split("T")[0];
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.locationsIds = localStorage.getItem("locations");
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
